import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { pageFromProps } from 'helpers/utilities'

import { orderActions, userActions } from 'redux/actionCreators'
import classes from './Wishlist.scss'

import { get } from 'lodash'
import { Pagination, ProductItem } from 'components'

const mapStateToProps = (state) => ({
  cartProductMap: get(state, ['order', 'cartProductMap']) || {},
  wishlist: get(state, 'user.wishlist') || [],
  pageCount: get(state, 'user.pageCount') || 0,
  userClass: get(state, 'user.me.userClass') || 0
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptFindWishlist: () =>
    dispatch(userActions.attemptFindWishlist({
      offset: (pageFromProps(ownProps) - 1) * 100,
      limit: 100
    })),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode }))
})

@connect(mapStateToProps, mapDispatchToProps)
class Wishlist extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentDidMount () {
    this.props.attemptFindWishlist()
  }

  _renderProduct = (product) =>
    <div key={product.productCode} className={classes.productItemWrapper}>
      <ProductItem
        product={product}
        amount={get(this.props, ['cartProductMap', `${product.productCode}-0`, 'amount'])}
        userClass={this.props.userClass}
        onAddToCart={this.props.attemptAddToCart}
        onAddToWishlist={this.props.attemptAddToWishlist}
        onRemoveFromWishlist={this.props.attemptRemoveFromWishlist} />
    </div>

  render () {
    const { wishlist, location, pageCount } = this.props
    return (
      <section className={classes.wishlist}>
        <Helmet title='WISH LIST' />
        {wishlist.length ? (
          <div>
            <Pagination router={this.context.router} location={location} pageCount={pageCount} />
            <div>
              {wishlist.map(this._renderProduct)}
            </div>
            <Pagination router={this.context.router} location={location} pageCount={pageCount} />
          </div>
        ) : (
          <div className={classes.noData}>ยังไม่มีข้อมูล WISHLIST</div>
        )}
      </section>
    )
  }
}

export default Wishlist



/** WEBPACK FOOTER **
 ** ./src/containers/User/Wishlist/Wishlist.js
 **/